import { getSnippets, loadCollectionItems } from '../pluginComponentApi';
//TODO: Discuss with Ketan
//TODO: Duplicate of getSnippetRoleTraits snippet=> snippetTraits
export const getSubPageTraits = async (projectId, version, labelColName) => {
  const snippets = await getSnippets(projectId, version, labelColName);
  let options = [];
  options.push({ value: '', name: '- Select Sub Page -' });
  snippets.data
    .filter((snippet) => snippet.snippetType === 'SUB_PAGE')
    .forEach((item) => {
      options.push({ value: item.uuid, name: item.name });
    });
  return {
    type: 'select',
    label: labelColName,
    name: 'subPageUuid',
    changeProp: 1,
    options,
  };
};
//TODO: Discuss with Ketan
//TODO: Duplicate of getSnippetRoleTraits snippet=> snippetTraits
export const getSubPageRoleTraits = async (projectId, version, labelColName) => {
  const snippets = await getSnippets(projectId, version, labelColName);
  let options = [{ value: '', name: '- Select Sub Page -' }];
  snippets.data
    .filter((snippet) => snippet.snippetType === 'SUB_PAGE')
    .forEach((item, key) => {
      options.push({ value: item.uuid, name: item.name });
    });

  const collectionItems = await loadCollectionItems(projectId, version, 'role');
  let snippetRoleTraitsMap = [];
  collectionItems.forEach((item, key) => {
    snippetRoleTraitsMap.push({ userRole: item, snippetOptions: options });
  });

  return snippetRoleTraitsMap;
};
